import axios from 'axios';
import { Cache } from './cache';

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // Your API base URL
  // timeout: 10000, // Timeout in milliseconds (optional)
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false,
});

http.interceptors.request.use(
  (config) => {
    //Attach tokens if exists
    const token = Cache.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {  
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export default http;